import styled from 'styled-components';
import get from 'lodash/get';

export const HeadingStyled = styled.h1`
  background-color: ${props =>
    props.bgColor && props.theme.colors.get(props.bgColor)};
  ${props => get(props.theme.typography, props.typography.mobile)};
  text-align: ${props => props.position};
  padding-top: ${props => props.theme.spacing(props.paddingTop)};
  @media ${props => props.theme.laptop} {
    ${props => get(props.theme.typography, props.typography.desktop)};
  }
`;

export const HeadingWithBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.position};
`;
